// extracted by mini-css-extract-plugin
export var link = "_ul-0";